import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Confirmation from './components/Confirmation';
import Results from './components/Results';
//import OAuthRedirect from './components/OAuthRedirect';
import PrivateRoute from './components/PrivateRoute';
import Navbar from './components/Navbar';
import Dashboard from './components/Dashboard';
import AboutUs from './components/AboutUs'; 
import DataRequest from './components/DataRequest';
import UserInfoPanel from './components/UserInfoPanel';

// Goal: setup the routes for the app
function App() {
  return (
    <Router>
      <Navbar />
      <Routes>
        {/* Redirect root to login if not authenticated */}
        <Route path="/" element={<Navigate to="/login" replace />} />
        
        {/* Public routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/about" element={<AboutUs />} />
        {
        /*<Route 
          path="/oauth/callback" 
          element={<OAuthRedirect />} 
        />*/
        }
        
        {/* Protected routes */}
        <Route 
          path="/confirm" 
          element={
            <PrivateRoute>
              <Confirmation />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/dashboard" 
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/data-request" 
          element={
            <PrivateRoute>
              <DataRequest />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/user-info" 
          element={
            <PrivateRoute>
              <UserInfoPanel />
            </PrivateRoute>
          } 
        />
        <Route 
          path="/results" 
          element={
            <PrivateRoute>
              <Results />
            </PrivateRoute>
          } 
        />

        {/* Catch all route - redirect to login */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
